import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import { assertResponseSuccess, generateRequestID, getSwicusWebAppUrl } from '../utils/api';
export var fetchProductsActivationInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(environment, orgId) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch("".concat(getSwicusWebAppUrl(environment), "/v1/products-activation-info?org_id=").concat(orgId), {
              headers: {
                'content-type': 'application/json',
                'x-request-id': generateRequestID()
              },
              method: 'GET',
              credentials: 'include'
            });

          case 2:
            result = _context.sent;
            assertResponseSuccess(result);
            _context.next = 6;
            return result.json();

          case 6:
            return _context.abrupt("return", _context.sent);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchProductsActivationInfo(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();